import { render } from "./User.vue?vue&type=template&id=fea9d426"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fea9d426"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fea9d426', script)) {
    api.reload('fea9d426', script)
  }
  
  module.hot.accept("./User.vue?vue&type=template&id=fea9d426", () => {
    api.rerender('fea9d426', render)
  })

}

script.__file = "src/icons/components/filled/User.vue"

export default script